import React from 'react';
import {useDispatch} from "react-redux";
import classnames from 'classnames';
import {showSkinDetailPopup} from "../../../actions/popup"
import {ARCHIVE} from "../../../constants/design/SkinTypes"
import SkinCardPreview from './SkinCardPreview'
import SkinCardDesc from "./SkinCardDesc"
import SkinCardActions from "./SkinCardActions"

export default function SkinCard({skin, type, currentSkin, onChangeFilter, deleteArchive, onSetSkin}) {
  const dispatch = useDispatch()

  function handleShowSkinDetail(skin) {
    dispatch(showSkinDetailPopup(skin))
  }

  const selected = skin.skinName === currentSkin.name;
  return (
    <div className={classnames({
      "item_skin": true,
      "on": selected,
      "item_skin_archive": type === ARCHIVE
    })}>

      <SkinCardPreview
        skin={skin} type={type} currentSkin={currentSkin}
        onClick={handleShowSkinDetail}
      />

      <SkinCardDesc
        skin={skin} type={type}
        onSelect={handleShowSkinDetail}
        onChangeFilter={onChangeFilter}
      />

      <SkinCardActions
        skin={skin} type={type} selected={selected}
        onSet={onSetSkin}
        onDelete={deleteArchive}
      />
    </div>
  )
}
